<div class="modal-container">
  <div class="modal-header">
    <h2>Momentos WOW</h2>
    <button mat-icon-button class="close-btn" (click)="close()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <p class="modal-description">
      <strong>Estos son los momentos WOW para celebrar. Selecciona una categoria para ver los eventos de tu población.</strong>
    </p>

    <div class="categories">
      <button
        mat-raised-button
        class="category-btn"
        [class.active]="selectedCategory === 'cumpleanos'"
        (click)="selectCategory('cumpleanos')"
      >
        <span class="count-badge"><span class="count-value">{{ getCount('cumpleanos') }}</span></span>
        <span class="btn-text">Cumpleaños</span>
      </button>

      <button
        mat-raised-button
        class="category-btn"
        [class.active]="selectedCategory === 'quinquenios'"
        (click)="selectCategory('quinquenios')"
      >
        <span class="count-badge"><span class="count-value">{{ getCount('quinquenios') }}</span></span>
        <span class="btn-text">Quinquenios</span>
      </button>

      <button
        mat-raised-button
        class="category-btn"
        [class.active]="selectedCategory === 'nacimientos'"
        (click)="selectCategory('nacimientos')"
      >
        <span class="count-badge"><span class="count-value">{{ getCount('nacimientos') }}</span></span>
        <span class="btn-text">Nacimientos</span>
      </button>
    </div>

    <div class="table-scroll-container">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="wow-table"
      >
        <ng-container matColumnDef="nombreCompleto">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
          <td mat-cell *matCellDef="let row">{{ row.nombreCompleto }}</td>
        </ng-container>

        <ng-container matColumnDef="fechaAntiguedad">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de antiguedad</th>
          <td mat-cell *matCellDef="let row">{{ row.fechaAntiguedad }}</td>
        </ng-container>

        <ng-container matColumnDef="parentesco">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Parentesco Real</th>
          <td mat-cell *matCellDef="let row">{{ row.parentesco || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="fechaCumpleanosConEdad">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de cumpleanos</th>
          <td mat-cell *matCellDef="let row">{{ row.fechaCumpleanosConEdad || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="quinquenios">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Quinquenios</th>
          <td mat-cell *matCellDef="let row">{{ row.quinquenios || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="fechaIngreso">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de ingreso</th>
          <td mat-cell *matCellDef="let row">{{ row.fechaIngreso || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="celular">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Celular</th>
          <td mat-cell *matCellDef="let row">{{ row.celular }}</td>
        </ng-container>

        <ng-container matColumnDef="correoElectronico">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Correo</th>
          <td mat-cell *matCellDef="let row">{{ row.correoElectronico }}</td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let row">
            <button
              mat-icon-button
              class="action-check"
              (click)="markAsManaged(row)"
              aria-label="Confirmar gestion"
            >
              <mat-icon>check</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div class="empty-state" *ngIf="dataSource.data.length === 0">
      No hay eventos vigentes para esta categoría.
    </div>

    <mat-paginator
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>